import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ManageLibraryFormsPage = styled.div`
  width: 100%;
  height: 100%;

  .button-group{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 8px;
  }
  .filter-bar{
    width: 100%;
    margin-bottom: 12px;
  }
  .filter-bar .ant-select,
  .filter-bar .ant-input-search{
    width: 100%;
  }
  /* Strip the inner .ant-input border the allowClear affix-wrapper stacks on
     top of the app's global input border (reads as a double/inner border). */
  .ant-input-search .ant-input-affix-wrapper > .ant-input{
    border: none;
    box-shadow: none;
  }
  .ant-pagination .ant-pagination-item-active{
    border-color: #0B2A1B;
  }
  .ant-pagination a:hover,.ant-pagination-item-link:hover{
    color: #0B2A1B;
  }
  .ant-pagination .ant-pagination-item-active a{
    color:#0B2A1B;
  }
`;

// Wrapper for the Form Categories tab. Strips the inner .ant-input border that
// the allowClear affix-wrapper stacks on top of the app's global input border
// (which otherwise reads as a double/inner border on the search box).
const FormCategoriesWrapperStyle = styled.div`
  width: 100%;

  .ant-input-search .ant-input-affix-wrapper > .ant-input {
    border: none;
    box-shadow: none;
  }
`;

export const FormCategoriesWrapper = WithDirection(FormCategoriesWrapperStyle);

export default WithDirection(ManageLibraryFormsPage);
